import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { Button } from 'reactstrap';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import { EventToolbox } from 'client/utils/event-toolbox';
import { getStepCtaAriaLabel } from 'site-modules/shared/components/appraisal/trade-in-appraiser/utils/trade-in-appraiser-utils';
import {
  APPRAISER_STEP_BUTTON_TRACKING,
  CONTINUE_BUTTON_CLASSNAME,
  PARTNER_OFFER_CONDITIONS,
} from 'site-modules/shared/constants/appraisal/appraisal';

export const TradeInAppraiserItemContinueBtn = ({
  id,
  stepCounter,
  nextStepTitle = '',
  onContinue,
  nextId = '',
  isNextStepLoaded,
  ctaText: ctaTextFromProps = '',
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const ctaText = isLoaded ? 'Continue' : 'Loading...';
  const disabled = !isLoaded || !isNextStepLoaded;
  const ariaLabel = getStepCtaAriaLabel(stepCounter, nextStepTitle, !disabled);
  const isOfferConditionsStep = id === PARTNER_OFFER_CONDITIONS;

  useEffect(() => {
    EventToolbox.domReady(() => {
      setIsLoaded(true);
    });
  }, []);

  return (
    <ScrollElement
      id={isOfferConditionsStep ? 'cta-offer-conditions-step' : `step-${id}`}
      tag={Button}
      type="submit"
      onClick={disabled ? noop : onContinue}
      data-index={nextId}
      data-tracking-id={APPRAISER_STEP_BUTTON_TRACKING[id]}
      color="success"
      className={classnames(
        'trade-in-appraiser-item-cta heading-5 text-white py-0_5 form-button text-transform-none pos-r d-block w-100',
        CONTINUE_BUTTON_CLASSNAME,
        { 'cq-cta': isOfferConditionsStep, disabled }
      )}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      tabIndex={0}
      data-testid={getStepCtaAriaLabel(stepCounter, nextStepTitle)}
    >
      {!isNextStepLoaded && (
        <span className="pe-0_5">
          <Spinner size={14} thickness={1} color="white" />
        </span>
      )}
      {ctaTextFromProps || ctaText}
    </ScrollElement>
  );
};

TradeInAppraiserItemContinueBtn.propTypes = {
  id: PropTypes.string.isRequired,
  stepCounter: PropTypes.number.isRequired,
  nextStepTitle: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  nextId: PropTypes.string,
  isNextStepLoaded: PropTypes.bool.isRequired,
  ctaText: PropTypes.string,
};
